<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="getYearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Month"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="month.value.value"
                                            :items="getMonthsList"
                                            :item-title="(item)=> item.title"
                                            item-value="value"
                                            :error-messages="month.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col md="2" cols="12">
                                            <v-btn
                                            class="bg-brand w-100"
                                            type="submit"
                                            ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Salary Bank Advice Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="px-2">
                                <v-row class="py-2 justify-items-between">

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-printer"
                                                variant="flat"
                                                color="indigo"
                                                @click="printReport"
                                                >PRINT</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                </v-row>

                                <div id="printable-area" class="py-2">
                                    <v-card class="my-2" elevation="0">
                                        <v-card-title class="bg-primary text-white text-center">
                                            <div class="w-100">
                                                <div class="text-h5 font-weight-bold">{{  titleShow(month.value.value, year.value.value) }}</div>
                                            </div>
                                        </v-card-title>
                                    </v-card>

                                    <div v-if="getSchema?.data">
                                        <div v-for="(bankGroup, bankId) in getSchema?.data" :key="bankId" class="mb-4">
                                            <div class="bank-header">
                                                <h4>
                                                    {{ bankGroup[0]?.bank?.name || 'Unknown Bank' }}
                                                </h4>
                                            </div>
                                            <v-data-table
                                                :headers="headers"
                                                :items="bankGroup"
                                                :loading="loading"
                                                :search="search"
                                                :hover="true"
                                                density="compact"
                                                hide-default-footer
                                                class="custom-bordered-table"
                                            >
                                                <template v-slot:item="{ item, index }">
                                                    <tr>
                                                        <td class="text-center">{{ index + 1 }}</td>
                                                        <td class="text-left">{{ item.employee?.code }}</td>
                                                        <td class="text-left">{{ item.employee?.name }}</td>
                                                        <td class="text-left">{{ item.designation?.name }}</td>
                                                        <td class="text-center">{{ item.account_number }}</td>
                                                        <td class="text-right">{{ parseFloat(item.amount).toFixed(2) }}</td>
                                                    </tr>
                                                </template>
                                                
                                                <!-- Add total row -->
                                                <template v-slot:body.append>
                                                    <tr class="row-total">
                                                        <td colspan="5" class="text-right">Total:</td>
                                                        <td class="text-right">{{ calculateBankTotal(bankGroup) }}</td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
    
                                        </div>
                                        <div v-if="getSchema?.total" class="grand-total-bar">
                                            <div class="amount-words">{{ getSchema?.total_in_words }}</div>
                                            <div class="grand-total">Grand Total Taka: <span>{{ parseFloat(getSchema?.total).toFixed(2) }}</span></div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <v-card elevation="1" class="text-center py-0">
                                            <v-card-text class="text-caption text-grey-darken-1">
                                                No Data Found
                                            </v-card-text>
                                        </v-card>
                                    </div>

                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import numberToWords from "number-to-words";

export default {
    data: () => ({
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
            { title: "Employee Code", key: "employee.code", align: "center", sortable: false },
            { title: "Name", key: "employee.name", align: "center", sortable: false },
            { title: "Designation", key: "designation.name", align: "center", sortable: false },
            { title: "A/C No", key: "account_number", align: "center", sortable: false },
            { title: "Amount (Taka)", key: "amount", align: "center", sortable: false },
        ],
        years: [],
        months: [
            { title: "January", value: 1 },
            { title: "February", value: 2 },
            { title: "March", value: 3 },
            { title: "April", value: 4 },
            { title: "May", value: 5 },
            { title: "June", value: 6 },
            { title: "July", value: 7 },
            { title: "August", value: 8 },
            { title: "September", value: 9 },
            { title: "October", value: 10 },
            { title: "November", value: 11 },
            { title: "December", value: 12 },
        ],
    }),
    computed: {
        getSchema() {
            return this.$store.getters.getSalaryBankAdviceReport;
        },
        getYearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();

            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }

            return this.years;
        },
        getMonthsList() {
            return this.months;
        },
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl || '';
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const month = useField("month");
        const year = useField("year");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            store
                .dispatch("getSalaryBankAdviceReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            month,
            year,
            submit,
            loading,
        };
    },
    methods: {
        calculateBankTotal(bankGroup) {
            const total = bankGroup.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            return total.toFixed(2);
        },
        titleShow(month, year) {
            if (month && year) {
                return `Salary Bank Advice Report for ${this.getMonthsList[month-1].title}, ${year}`;
            } else if (year) {
                return `Salary Bank Advice Report for ${year}`;
            } else if (month) {
                return `Salary Bank Advice Report for ${this.getMonthsList[month-1].title}`;
            } else {
                return `Salary Bank Advice Report`;
            }
        },
        printReport() {
            const printContent = document.getElementById("printable-area").innerHTML;
            const baseRaw = this.getSchema;
            console.log(baseRaw)
            const raw = this.getSchema?.data || [];
            const groupsArray = raw[1]
            const firstItem = groupsArray[0] || [];
            const companyInfo = firstItem?.branch?.company;
            
            const companyName = companyInfo?.name;
            const companyAddress = companyInfo?.address;
            const companyMobile = companyInfo?.mobile;
            const companyEmail = companyInfo?.email;
            const companyWebsite = companyInfo?.website;

            let companyLogo = '';
            if (companyInfo?.logo) {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/${companyInfo.logo}`;
            } else {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/uploads/demo_images/user.png`;
            }
            
            const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

            // Letter meta
            const bankTitle = firstItem.bank?.name;
            const branchTitle = firstItem.branch?.name || '';
            const branchAddress = firstItem.branch?.address || '';
            const monthName = this.getMonthsList[(this.month.value.value - 1) || (new Date().getMonth())]?.title ;
            const yearVal = this.year.value.value || new Date().getFullYear();
            const today = new Date().toISOString().split('T')[0];
            const allItems = groupsArray.flat();
            const totalAmount = allItems.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            const formattedTotal = this.$numberFormat(Number(totalAmount));
            const amountWords = numberToWords.toWords(Math.round(totalAmount));
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Salary Bank Advice Report - ${this.year.value.value || new Date().getFullYear()}</title>
                    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    
                    body {
                        font-family: 'Times New Roman', serif;
                        background: white;
                        margin: 0;
                        padding: 20px;
                    }
                    .report-paper {
                        background-color: white;
                        color: black;
                        max-width: 100%;
                        width: 100%;
                        margin: auto;
                    }
                    .main-header-section {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        border-bottom: 2px solid #eee;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        padding-bottom: 10px;
                        margin-bottom: 16px;
                    }
                    .company-info {
                        flex: 1;
                    }
                    .company-name {
                        color: #333;
                        font-size: 14px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0 0 4px 0;
                    }
                    .company-text {
                        font-size: 11px;
                        color: #555;
                        margin: 2px 0;
                        display: flex;
                        align-items: center;
                    }
                    .logo-container img {
                        max-height: 70px;
                        max-width: 150px;
                    }
                    .report-title {
                        color: #333;
                        font-size: 11px;
                        font-weight: bold;
                        text-align: center;
                        margin: 8px 0;
                    }
                    
                    .report-info {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;
                        font-size: 13px;
                        color: #333;
                    }
                    
                    .report-info-left {
                        font-weight: 500;
                    }
                    
                    .report-info-right {
                        font-weight: 500;
                    }

                    /* Bank headers and totals */
                    .bank-header {
                        margin: 20px 0 6px 0;
                    }

                    .bank-header h4 {
                        font-size: 11px;
                        font-weight: 700;
                    }

                    .row-total td {
                        font-weight: 700;
                        background-color: #f5f5f5 !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }

                    .v-card {
                        display: none;
                    }
                    
                    .font-weight-bold {
                        font-weight: bold;
                    }
                    
                    .w-100 {
                        width: 100%;
                    }
                    
                    .text-center {
                        text-align: center;
                    }
                    
                    .text-left {
                        text-align: left;
                    }
                    
                    .text-right {
                        text-align: right;
                    }
                    
                    .custom-bordered-table {
                        width: 100%;
                        margin-top: 0;
                    }
                    
                    .custom-bordered-table table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 11px;
                    }
                    
                    .custom-bordered-table thead {
                        display: table-header-group;
                    }
                    
                    .custom-bordered-table thead th {
                        background-color: #f5f5f5 !important;
                        border: 1px solid #000000 !important;
                        padding: 8px 4px;
                        font-weight: bold;
                        color: #000;
                        vertical-align: middle;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .custom-bordered-table tbody td {
                        border: 1px solid #000000 !important;
                        padding: 6px 4px;
                        vertical-align: middle;
                        color: #000;
                    }
                    
                    .custom-bordered-table tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .merged-cell {
                        font-weight: 500;
                    }
                    
                    /* Hide pagination and other v-data-table controls */
                    .v-data-table-footer,
                    .v-data-table__wrapper + div,
                    .v-pagination {
                        display: none !important;
                    }

                    .letter-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 20px;
                        font-size: 11px;
                        color: #000;
                        padding: 10px 0;
                    }

                    .letter-address {
                        margin-top: 10px;
                        margin-bottom: 20px;
                        font-size: 11px;
                        color: #000;
                        line-height: 1.6;
                    }
                        
                    .underline {
                        text-decoration: underline;
                    }

                    .letter-greeting {
                        margin: 20px 0 14px 0;
                        font-size: 11px;
                    }

                    .letter-paragraph {
                        font-size: 11px;
                        color: #000;
                        line-height: 1.7;
                        margin-bottom: 16px;
                    }

                    .grand-total-bar {
                        background-color: #EBEBEB;
                        font-size: 11px;
                        display: grid;
                        grid-template-columns: 1fr auto;
                        gap: 11px;
                        align-items: center;
                        border: 1px solid #000;
                        padding: 8px 10px;
                        margin-top: 14px;
                    }
                    .grand-total-bar .amount-words { font-weight: 600; }
                    .grand-total-bar .grand-total { font-weight: 700; }
                    .grand-total-bar .grand-total span { display: inline-block; min-width: 120px; text-align: right; }

                    .signature-block {
                        font-size: 11px;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 40px;
                        margin-top: 150px;
                    }
                    .signature-block .sig-line { border-bottom: 1px solid #000; width: 60%; margin: 0 auto 6px auto; }
                    .signature-block .sig-text { text-align: center; font-weight: 600; }
                    
                    @page {
                        size: portrait;
                        margin: 0.5cm;
                    }
                    
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            background: white !important;
                            padding: 0;
                        }
                        .page-header {
                            display: table-header-group;
                        }
                        .page-content {
                            display: table-row-group;
                        }
                        
                        .custom-bordered-table thead {
                            display: table-header-group;
                        }
                        
                        .custom-bordered-table thead th {
                            background-color: #f5f5f5 !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        
                        .custom-bordered-table tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                        
                        table {
                            page-break-inside: auto;
                        }
                    }
                    </style>
                </head>
                <body>
                    <!-- Company Header -->
                    
                        <div class="main-header-section">
                            
                            <div class="header-section w-100">
                                <div class="company-info">
                                    <h4 class="company-name">${companyName}</h4>
                                    <p class="company-text">${companyAddress}</p>
                                    <p class="company-text">
                                        <span class="mdi mdi-phone-outline"></span>
                                        ${companyMobile}
                                    </p>
                                    <p class="company-text">
                                        <span class="mdi mdi-email-outline"></span>
                                        ${companyEmail}
                                    </p>
                                    ${companyWebsite ? `<p class="company-text">
                                        <span class="mdi mdi-web"></span>
                                        ${companyWebsite}
                                    </p>` : ''}
                                </div>
                                <div class="logo-container">
                                    <img src="${companyLogo}" alt="Company Logo" />
                                </div>
                            </div>  
                            
                            <div class="text-center underline">
                                <p class="report-title">Transfer of Fund against salary for Employees</p>
                            </div>
                        </div>
                        
                    <!-- Report Title -->
                    
                    
                    <!-- Letter Style Application -->
                    <div class="letter-meta">
                        <div>Date: ${today}</div>
                    </div>
                    
                    <div class="letter-address">
                        <div>Manager</div>
                        <div>${bankTitle || ''}</div>
                        <div>${branchAddress || ''}</div>
                    </div>
                    
                    <div class="letter-greeting">Dear sir,</div>
                    
                    <div class="letter-paragraph">
                        Please arrange to transfer the following amount against the name of Employees' in their respective savings account with
                        various banks, by debiting our current account No. 07, amounting to Tk. ${formattedTotal} ( ${amountWords} Taka ) only
                        against the salary for the month of ${monthName}, ${yearVal}.
                    </div>
                                    
                    <!-- Report Content -->
                    ${printContent}
                    <div class="signature-block">
                        <div class="signature">
                            <div class="sig-line"></div>
                            <div class="sig-text">Authorised Signature</div>
                        </div>
                        <div class="signature">
                            <div class="sig-line"></div>
                            <div class="sig-text">Authorised Signature</div>
                        </div>
                    </div>
                </body>
            </html>
            `);

            printWindow.document.close();
            printWindow.moveTo(0, 0);
            printWindow.focus();
            
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 1000);
        },


        exportToExcel() {
            const data = [
                ["Bank Name", "Employee Code", "Name", "Designation", "A/C No", "Amount (Taka)"]
            ];

            let serialNumber = 1;

            if (this.getSchema?.data) {
                // Loop through each bank group
                Object.keys(this.getSchema.data).forEach((bankId) => {
                    const bankGroup = this.getSchema.data[bankId];
                    const bankName = bankGroup[0]?.bank?.name || 'Unknown Bank';

                    // Add bank group items
                    bankGroup.forEach((item) => {
                        data.push([
                            bankName,
                            item.employee?.code,
                            item.employee?.name,
                            item.designation?.name,
                            item.account_number,
                            parseFloat(item.amount || 0).toFixed(2)
                        ]);
                        serialNumber++;
                    });

                    // Add bank total row
                    const bankTotal = this.calculateBankTotal(bankGroup);
                    data.push([
                        '',
                        '',
                        '',
                        '',
                        'Bank Total:',
                        bankTotal
                    ]);

                    // Add empty row for spacing between banks
                    data.push(['', '', '', '', '', '']);
                });

                // Add grand total
                if (this.getSchema?.total) {
                    data.push([
                        '',
                        '',
                        '',
                        '',
                        'Grand Total Taka:',
                        parseFloat(this.getSchema.total).toFixed(2)
                    ]);
                    data.push([
                        this.getSchema.total_in_words,
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                }
            }

            this.$exportTableToExcel(data, "salary_bank_advice_report_" + this.$fileDate());
        },

        exportToCSV() {
            const data = [
                ["Bank Name", "Employee Code", "Name", "Designation", "A/C No", "Amount (Taka)"]
            ];

            let serialNumber = 1;

            if (this.getSchema?.data) {
                // Loop through each bank group
                Object.keys(this.getSchema.data).forEach((bankId) => {
                    const bankGroup = this.getSchema.data[bankId];
                    const bankName = bankGroup[0]?.bank?.name || 'Unknown Bank';

                    // Add bank group items
                    bankGroup.forEach((item) => {
                        data.push([
                            bankName,
                            item.employee?.code,
                            item.employee?.name,
                            item.designation?.name,
                            item.account_number,
                            parseFloat(item.amount || 0).toFixed(2)
                        ]);
                        serialNumber++;
                    });

                    // Add bank total row
                    const bankTotal = this.calculateBankTotal(bankGroup);
                    data.push([
                        '',
                        '',
                        '',
                        '',
                        'Bank Total:',
                        bankTotal
                    ]);

                    // Add empty row for spacing between banks
                    data.push(['', '', '', '', '', '']);
                });

                // Add grand total
                if (this.getSchema?.total) {
                    data.push([
                        '',
                        '',
                        '',
                        '',
                        'Grand Total Taka:',
                        parseFloat(this.getSchema.total).toFixed(2)
                    ]);
                    data.push([
                        this.getSchema.total_in_words,
                        '',
                        '',
                        '',
                        '',
                        ''
                    ]);
                }
            }

            this.$exportTableToCSV(data, "salary_bank_advice_report_" + this.$fileDate());
        },
    },

    mounted() {
        // this.$refs.searchButton.$el.click();
    },
};
</script> 

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
    padding: 11px 0;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}

.grand-total-bar {
    background-color: #EBEBEB;
    font-size: 11px;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 11px;
    align-items: center;
    border: 1px solid #000;
    padding: 8px 10px;
    margin-top: 8px;
}
.grand-total-bar .amount-words { font-weight: 600; }
.grand-total-bar .grand-total { font-weight: 700; }
.grand-total-bar .grand-total span { display: inline-block; min-width: 120px; text-align: right; }

.bank-header {
    margin: 20px 0 6px 0;
}

.row-total td {
    font-weight: 700;
    background-color: #f5f5f5 !important;
}

/* Print Styles */
@media print {
    /* Hide unnecessary elements */
    .v-expansion-panel:first-child,
    .v-btn-group,
    .v-navigation-drawer,
    .v-app-bar,
    .v-footer {
        display: none !important;
    }

    /* Expand the report panel */
    .v-expansion-panel-text {
        display: block !important;
        max-height: none !important;
    }

    /* Full width for print */
    .v-container {
        max-width: 100% !important;
        padding: 0 !important;
    }

    /* Table styles for print */
    .custom-bordered-table ::v-deep() table {
        width: 100% !important;
        page-break-inside: auto;
        font-size: 10px;
    }

    .custom-bordered-table ::v-deep() thead {
        display: table-header-group;
    }

    .custom-bordered-table ::v-deep() tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    .custom-bordered-table ::v-deep() thead th,
    .custom-bordered-table ::v-deep() tbody td {
        border: 1px solid #000000 !important;
        padding: 6px 4px;
    }

    /* Card title styling */
    .v-card-title {
        background-color: #1976d2 !important;
        color: white !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    /* Remove shadows and elevations */
    .v-card {
        box-shadow: none !important;
    }

    /* Adjust page margins */
    @page {
        margin: 0.5cm;
        size: po;
    }
}
</style>
                    
